import Header from '../../components/Header';
import Card from './components/Card';

import { Container, Content } from './styles';

const Comments = () => {
  return (
    <Container>
      <Header />
      <Content>
        <h1>Comentários</h1>
      </Content>
      <Card />
    </Container>
  );
};

export default Comments;
